import React from 'react';
import { BUTTON_VARIANT } from '../../../../components/core/AonButton/consts';
import { AonButton } from '../../../../components/core/AonButton';
import { AonCheckbox } from '../../../../components/core/AonCheckbox';
import { useClientPageStore } from '../../../../store';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["Selected"] = "Selected Staff(s)";
    ColumnTitle["user"] = "Name";
    ColumnTitle["email"] = "Email";
    ColumnTitle["Type"] = "Type";
    ColumnTitle["Update"] = "Actions";
})(ColumnTitle || (ColumnTitle = {}));
;
export var columns = function (onClickSelected, sortBy, sortColumn, handleSorting, apiLoading, onRowEventTrigger) {
    var SelectedMarketCell = function (info) {
        var clientStore = useClientPageStore();
        var style = info.node.rowHeight === 30 ? { marginTop: "3px" } : { marginTop: "12px" };
        return (React.createElement("span", null,
            React.createElement(AonCheckbox, { disabled: !clientStore.isUserHaveFullAccess, style: style, onClick: function (event) { return onClickSelected(event, info.node.rowIndex); }, checked: info.getValue() })));
    };
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return apiLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var ActionCell = function (info) {
        var clientStore = useClientPageStore();
        return (React.createElement("span", null,
            React.createElement(AonButton, { style: { marginRight: "10px" }, disabled: !clientStore.isUserHaveFullAccess, variant: BUTTON_VARIANT.TEXT, onClick: function () {
                    onRowEventTrigger(info.node.rowIndex, false);
                } }, "Delete"),
            React.createElement(AonButton, { style: { marginLeft: "10px" }, disabled: !clientStore.isUserHaveFullAccess, variant: BUTTON_VARIANT.TEXT, onClick: function () {
                    onRowEventTrigger(info.node.rowIndex, true);
                } }, "Edit")));
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    return ([
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "selected", cellRenderer: SelectedMarketCell, headerName: ColumnTitle.Selected, sortable: false, flex: 0.5, minWidth: 150 },
        { field: "colleagueDisplayName", headerName: ColumnTitle.user, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
        { field: "colleagueEmail", headerName: ColumnTitle.email, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "associateType", headerName: ColumnTitle.Type, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
        { headerClass: "grid-header-center", cellStyle: CenterAlline, field: "accountGuid", cellRenderer: ActionCell, headerName: ColumnTitle.Update, sortable: false, flex: 1, minWidth: 150, headerComponent: headerConfig },
    ]);
};
